import React from 'react';
import './ServiceDetail.css';
import SubpagesLink from './SubpagesLink';
import TestimonialSection from './TestimonialSection';
import serviceImage from '../assets/service1.png';
import ndisLogo from '../assets/ramp-icon-update.png';
import SkewedContainer from 'sc-react';
import { Helmet } from 'react-helmet'; // Import Helmet for managing head tags
import SignupForm from './utils/SignupForm';
import HealthSection from './utils/HealthSection';

const Howoftenwillineedtoseemyndisphysio = () => {
    return (
        <div>
            <Helmet>
                <title>NDIS Physiotherapy Frequency Guide | Ramp Physio and Fitness</title>
                <meta name="description" content="Understand how often you may need to see an NDIS physiotherapist to optimize your rehabilitation and achieve your health goals." />
            </Helmet>
            <div className="service-detail-content">
                <div className="service-detail-text">
                    <br></br><br></br>
                    <h1>Understanding NDIS Physiotherapy Frequency</h1>
                    <h2>Discover how often you may need NDIS physiotherapy sessions to support your rehabilitation journey at Ramp Physio and Fitness.</h2>
                    <p>When it comes to NDIS physiotherapy, one of the most common questions we receive is, "How often will I need to see my NDIS physio?" The answer is not one-size-fits-all. At Ramp Physio and Fitness, we recognize that each individual's needs are unique, and your physiotherapy frequency will be tailored to support your specific health and fitness goals. This article aims to provide insight into the factors that determine session frequency and how we can help you navigate your NDIS physiotherapy plan.</p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="servicedetail-book-now"
                        onClick={() => {
                          window.gtag_report_conversion('https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1');
                        }}>
                        Book Now
                    </a>
                </div>
                <div className="service-detail-image-container">
                    <img src={serviceImage} alt="Service Detail" className="service-detail-image" />
                </div>
            </div>
            <SkewedContainer top="left" bottom="left" bgColor="white" noMargin>
                <div className="service-intro-container1">
                    <div className="service-intro-content1">
                        <h1>Personalized NDIS Physio Plans</h1>
                        <p>Every NDIS participant has a unique set of circumstances that influence the frequency of physiotherapy sessions. Factors such as the nature and severity of the disability, personal goals, and the stage of rehabilitation play a crucial role in determining how often you will need to visit your physiotherapist.</p>

                        <p>At Ramp Physio and Fitness, we start with a detailed assessment to create a personalized physio plan. This plan is designed to optimize your progress and ensure that each session contributes effectively to your overall rehabilitation goals.</p>
                    </div>
                    <div className="intro-image">
                        <img src="../assets/dumbbells.webp" alt="Exercise" />
                    </div>
                </div>
            <div className="service-intro-container2">
                <div className="intro-image">
                    <img src="../assets/massage.webp" alt="Exercise" />
                </div>
                <div className="service-intro-content2">
                    <h1>Factors Affecting Session Frequency</h1>
                    <p>Your physiotherapy journey is a dynamic process, and the frequency of your sessions may change over time. Some of the factors that can influence how often you see your NDIS physio include:</p>
                    <p>
                        <span>• Your current physical abilities and limitations</span><br />
                        <span>• The specific goals outlined in your NDIS plan</span><br />
                        <span>• Recommendations based on evidence-based practice</span><br />
                        <span>• Your response to treatment and rate of progress</span><br />
                        <span>• The availability of support from caregivers or family members</span><br />
                        <span>• Changes in your condition or living situation</span><br />
                        {/* Additional dot points */}
                    </p>
                </div>
            </div>
            </SkewedContainer>
            <SkewedContainer bottom="left" bgColor="white" noMargin>
                <div className="service-intro-container3">
                    <img src={ndisLogo} alt="NDIS Logo" className="service-intro-logo" />
                    <p className="service-intro-text">
                        Ramp Physio and Fitness
                    </p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="servicedetail-book-now"
                        onClick={() => {
                          window.gtag_report_conversion('https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1');
                        }}>
                        Book Now
                    </a>
                </div>
            </SkewedContainer>

            <div className="service-intro-container4">
                <div className="service-intro-content4">
                    <h1>Initial Intensive Treatment Phase</h1>
                    <p>In the early stages of your NDIS physiotherapy, sessions may be more frequent. This initial intensive phase focuses on establishing a foundation for recovery, managing pain, and improving mobility.</p>

                    <p>During this period, you might see your physiotherapist multiple times per week to ensure that you are on the right track and to make any necessary adjustments to your treatment plan.</p>
                </div>
                <div className="intro-image">
                    <img src="../assets/Gymfloor1.webp" alt="Exercise" />
                </div>
            </div>
            <SkewedContainer top="left" bgColor="#2980b9" noMargin>
            <div className="service-intro-container2">
                <div className="intro-image">
                    <img src="../assets/Pinloaded.webp" alt="Exercise" />
                    </div>
                    <div className="service-intro-content2">
                        <h1>Transition to Independent Management</h1>
                        <p>As you progress, the goal is to empower you with the skills and knowledge to manage your condition independently. This transition may lead to a reduction in the frequency of physiotherapy sessions.</p>
                        <p>You may move from several sessions per week to biweekly or monthly check-ins, as your physiotherapist continues to monitor your progress and adapt your plan as necessary.</p>
                    </div>
                </div>
            </SkewedContainer>
            <SubpagesLink />

            <HealthSection />
            <TestimonialSection />
        </div>
    );
};

export default Howoftenwillineedtoseemyndisphysio;